import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const HeroLines = ({ lines, className = "" }) => (
  <h1 className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${line.className || ""}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: 0.25 + i * 0.14, ease: [0.16, 1, 0.3, 1] }}
        >
          {line.text}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const ChapterHeading = ({ num, title, className = "" }) => (
  <Reveal className={className}>
    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E50914]">
      [{num}]
    </p>
    <h2 className="font-display uppercase leading-[0.95] tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-4">
      {title}
    </h2>
  </Reveal>
);
